import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

export default function initLottieAnimations() {
  if (document.querySelector('#eventLottie')) {
    create({
      mode: 'scroll',
      player: '#eventLottie',
      actions: [
        {
          visibility: [0.3, 1],
          type: 'playOnce',
        },
        {
          visibility: [1],
          type: 'stop',
          frames: [23]
        }
      ],
    });
  }
}
